import { type Offer } from "@core/offers/types";
import { OfferCard } from "../../offers/components/OfferCard";

interface OffersCarouselProps {
  offers: Offer[];
  title?: string;
  description?: string;
}

export function OffersCarousel({
  offers,
  title,
  description,
}: OffersCarouselProps) {
  if (!offers || offers.length === 0) {
    return null;
  }

  return (
    <div className="space-y-6">
      {(title || description) && (
        <div className="text-center">
          {title && (
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 sm:text-3xl">
              {title}
              <span className="text-xl">🔥</span>
            </h2>
          )}
          {description && <p className="mt-2 text-gray-600 dark:text-gray-300">{description}</p>}
        </div>
      )}

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {offers.slice(0, 4).map((offer) => (
          <OfferCard key={offer.id} offer={offer} />
        ))}
      </div>
    </div>
  );
}
